const data = [
  { id: 1, link: "#", title: "Home" },
  { id: 2, link: "#about", title: "About" },
  { id: 3, link: "#product", title: "Product" },
  { id: 4, link: "#contact", title: "Contact" },
];

export default data;
